import { render, staticRenderFns } from "./VideoEditorComponent.vue?vue&type=template&id=050be78e&scoped=true&"
import script from "./VideoEditorComponent.vue?vue&type=script&lang=ts&"
export * from "./VideoEditorComponent.vue?vue&type=script&lang=ts&"
import style0 from "./VideoEditorComponent.vue?vue&type=style&index=0&id=050be78e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050be78e",
  null
  
)

export default component.exports